'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');
var TabSubNavTool = require('./tab__subnav__group__tool.js');
var TabSubNavButton = require('./tab__subnav__group__button.js');
var TabSubNavToggleButton = require('./tab__subnav__group__toggle_button.js');

/**
 * Creates a Submenu Group
 *
 * @class
 */

class TabSubNavToolsGroup extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'weight': 0
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `<div class="editor__tab__subnav__group js-editor__tab__subnav__group float" data-weight='<%- weight %>'></div>`;

        super.render();
    }

    /**
     * Adds a a tool to the submenu group
     *
     * @param {String} name - name for the tool
     * @param {String} description
     * @param {String} icon - icon string
     * @param {Integer} weight - higher weight = last position
     */

    addTool(name, description, icon, weight){
        var subnavtool = new TabSubNavTool({
            target: this.$el,
            fields: {
                'name': name,
                'description': description,
                'icon': icon,
                'weight': (_.isUndefined(weight) ? 0 : weight)
            }
        });

        this.sortTools();

        return subnavtool;
    }


    /**
     * Sort the tools according weight
     */

    sortTools(){
        var self = this;
        var groups = $('.js-editor__tab__subnav__sortable', this.$el);

        $('.js-editor__tab__subnav__group', this.$el).empty();

        var sortedgroup = _.sortBy(groups, function(item){
            return $(item).data('weight');
        });

        _.each(sortedgroup, function(item){
            $(self.$el).append($(item));
        });
    }

    /**
     * Adds a button to the submenu group
     *
     * @param {String} name - name for the tool
     * @param {String} description
     * @param {String} icon - icon string
     */

    addButton(name, description, icon, cssClass, extraClass){
        var subnavButton = new TabSubNavButton({
            target: this.$el,
            fields: {
                'name': name,
                'description': description,
                'icon': icon,
                'class': cssClass,
                'extraClass': extraClass
            }
        });

        return subnavButton;
    }

    /**
     * Adds a a toggle button to the submenu group
     *
     * @param {String} name - name for the tool
     * @param {String} description
     * @param {String} icon - icon string
     * @param {Integer} weight - higher weight = last position
     */

    addToggleButton(name, description, icon, weight, extraClass){
        var subnavToggleButton = new TabSubNavToggleButton({
            target: this.$el,
            fields: {
                'name': name,
                'description': description,
                'icon': icon,
                'weight': (_.isUndefined(weight) ? 0 : weight),
                'extraClass': extraClass
            }
        });

        this.sortTools();

        return subnavToggleButton;
    }
}

module.exports = TabSubNavToolsGroup;
